/**
 * A message as the reader sees it: one status line, then the answer as one card.
 * @param {{ content?: string, activity?: Object }} message
 * @returns {Array<Object>}
 */
export function activityParts(message) {
  const content = (message?.content || "").trim();
  const text = content ? [{ type: "text", content }] : [];
  return message?.activity
    ? [{ type: "activity", activity: message.activity }, ...text]
    : text;
}

/**
 * A saved turn's trail as the activity its status line renders, or null when it has
 * no steps. The trail holds the steps that finished; the time is until the answer began.
 * @param {Array} trail - the reply's `context_metadata.trail`
 * @param {Object|null|undefined} timing - the reply's `context_metadata.timing`
 * @returns {Object|null}
 */
export function savedActivity(trail, timing) {
  const steps = Array.isArray(trail)
    ? trail.filter(
        // An older trail also kept a tool's own loads as steps under it (`parent`).
        (e) => e.kind === "step" && e.status === "done" && !e.parent
      )
    : [];
  if (!steps.length) return null;
  return {
    steps: steps.map((e, i) => ({
      id: e.id || `step-h${i}`,
      kind: "tool",
      status: e.status,
      label: e.label,
    })),
    startedAt: null,
    durationMs: timing?.ttft_ms || timing?.total_ms || null,
    done: true,
    phase: "done",
    outcome: "done",
  };
}
